export default "__VITE_ASSET__COnsBfer__"